module.exports = __webpack_public_path__ + "static/img/ryzs_20230607172401.fbd064a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ryzs_20230607172401.jpg
// module id = bGbq
// module chunks = 1